export default __webpack_public_path__ + "1c1ab3e0b7d1cc4a1ab4b29198539f79.png";